import axios from 'axios';
import { showMessageError } from '../../others/toastr';
import { atualizaDependente, buscarParentescoPorPlano, insereDependente, removeDependente } from '../../../services/dependentes';

const prepararObjetoEdicaoDependentes = values => {
    values.Parentesco = values.Parentesco.trim();

    if (values.Nascimento === null) {
        delete values.Nascimento;
    }

    delete values.showPetForm;

    return values;
};

const prepararObjetoCadastrarDependentes = values => {
    values.Parentesco = values.Parentesco.trim();

    if (values.Nascimento === null) {
        delete values.Nascimento;
    }

    delete values.showPetForm;

    return values;
};

export const editarDependenteController = async (values, inscricao, contratoUpSell) => {
    try {
        const dependenteAtualizacao = prepararObjetoEdicaoDependentes(values);
        const respostaHttpAtualizarDependente = await atualizaDependente(
            dependenteAtualizacao,
            inscricao,
            contratoUpSell
        );
        const respostaTela = tratarRetornoTelaAtualizarDependente(respostaHttpAtualizarDependente);

        return respostaTela;
    } catch (error) {
        const respostaTela = {
            sucesso: false,
            mensagem: error.mesage
        };

        return respostaTela;
    }
};

const tratarRetornoTelaAtualizarDependente = httpReponse => {
    const respostaTela = {
        sucesso: false,
        mensagem: ''
    };

    switch (httpReponse.status) {
        case 200:
            respostaTela.sucesso = true;
            break;
        case 406:
            respostaTela.mensagem = 'Erro! esse dependente não pode ser mais editado';
            break;

        case 204:
            respostaTela.mensagem = 'Erro! esse dependente não pode ser mais editado';
            break;
        default:
            respostaTela.mensagem = 'Erro! verifique se todos os dados estão preenchidos';
            break;
    }

    return respostaTela;
};

export const cadastrarDependenteController = async (values, inscricao, subGrupoSelecionadoUpSell) => {
    try {
        const objCadastrarDependentes = prepararObjetoCadastrarDependentes(values);
        const respostaHttpCadastrarDependente = await insereDependente(inscricao, objCadastrarDependentes, subGrupoSelecionadoUpSell);
        const respostaTela = tratarRetornoTelaCadastrarDependente(respostaHttpCadastrarDependente);

        return respostaTela;
    } catch (error) {
        const respostaTela = {
            sucesso: false,
            mensagem: error.mesage
        };

        return respostaTela;
    }
};

const tratarRetornoTelaCadastrarDependente = httpReponse => {
    const respostaTela = {
        sucesso: false,
        mensagem: ''
    };

    switch (httpReponse.status) {
        case 200:
            respostaTela.sucesso = true;
            break;
        case 204:
            respostaTela.mensagem = 'Dependente já cadastrado!';
            break;

        case 202:
            respostaTela.mensagem = httpReponse.data.message;
            break;
        default:
            respostaTela.mensagem = 'Erro! verifique se todos os dados estão preenchidos';
            break;
    }

    return respostaTela;
};

export const removerDependenteController = async (inscricao, seq, contratoUpSell) => {
    await removeDependente(inscricao, seq, contratoUpSell);
};

export const buscarParentescoPorPlanoController = async plano => {
    const parentesco = await buscarParentescoPorPlano(plano);

    if (axios.isAxiosError(parentesco)) {
        showMessageError('Erro', parentesco?.response?.data?.message ?? 'Houve problemas a obter parentescos');

        return [];
    }

    return parentesco?.length ? parentesco?.map(dep => ({
        value: dep?.Parentesco?.Grau,
        label: dep?.Parentesco?.Descricao
    })) : [];
};
